module.exports = __webpack_public_path__ + "static/ssafeicon-25cc1ce25025848f16921a443e87906e.jpeg";